import React, { useState, useEffect } from "react";
import { usePromise } from "react-use";
import { getToken, createResetPasswordUAApp } from "../helpers/ad";

// pollyfill element.matches if missing
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function pollyfill(s) {
      const matches = (this.document || this.ownerDocument).querySelectorAll(s);

      let i = matches.length;
      // eslint-disable-next-line
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

// works like the jquery $.on event handler - delegates event to specified selector, keeping in
// sync as the children of the element are mutated
const delegate = (el, evt, sel, handler) => {
  el.addEventListener(evt, function eventHandler(event) {
    let t = event.target;
    while (t && t !== this) {
      if (t.matches(sel)) {
        handler.call(t, event);
      }
      t = t.parentNode;
    }
  });
};

const Login = ({ handleLogin }) => {
  const [loginPageContent, setLoginPageContent] = useState(null);
  const cancellablePromise = usePromise();

  const handleResetPasswordClick = async () => {
    const app = await createResetPasswordUAApp();

    cancellablePromise(
      app
        .loginPopup(process.env.REACT_APP_AD_SCOPES.split(","))
        .then(idToken => {
          handleLogin(idToken);
        })
    );
  };

  const handleLoginClick = async () => {
    cancellablePromise(
      getToken()
        .then(response => {
          handleLogin(response);
        })
        .catch(err => console.log(err))
    );
  };

  // The second param (`[]`) is to ensure the effect is fired once and only once
  useEffect(() => {
    setLoginPageContent(document.getElementById("loginPageContent").innerHTML);
    delegate(document, "click", "#client-dashboard-login", handleLoginClick);
    delegate(
      document,
      "click",
      "#client-dashboard-reset-password",
      handleResetPasswordClick
    );

    return () => {
      document.removeEventListener("click", handleLoginClick, false);
      document.removeEventListener("click", handleResetPasswordClick, false);
    };
  }, []);

  // trigger lozad lazy loader after any update
  useEffect(() => {
    // eslint-disable-next-line
    window.lozadObserver && window.lozadObserver.observe();
  });

  return (
    <div>
      <div
        className="pt-3"
        dangerouslySetInnerHTML={{ __html: loginPageContent }}
      />
    </div>
  );
};

export default Login;
